import { css } from '@firebolt-dev/css'
import { useEffect, useMemo, useRef, useState } from 'react'

import { storage } from '../web/storage'
import { uuid } from '../core/utils'
import { Client } from '../client/Client'
import { SocketRemote } from '../client/SocketRemote'

export function UIGame() {
  const viewportRef = useRef()
  const [client, setClient] = useState(null)
  const [err, setErr] = useState(null)

  const play = async () => {
    setErr(null)

    // check if webxr available
    const supportsVR = await navigator.xr?.isSessionSupported('immersive-vr')
    if (!supportsVR) {
      return setErr('Device does not support VR')
    }
    // if we dont have mic permission, get it
    const mic = await navigator.permissions.query({ name: 'microphone' })
    if (mic.state === 'denied') {
      return setErr('Microphone permission denied. Enable and try again.')
    }
    if (mic.state !== 'granted') {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        stream.getTracks().forEach(track => track.stop())
      } catch (err) {
        setErr('Microphone permission denied. Enable and try again.')
      }
      return
    }
    // enter vr

    // client.graphics.enterVR()

    let playerId = storage.get('playerId')
    if (!playerId) {
      playerId = uuid()
      storage.set('playerId', playerId)
    }

    const params = { playerId, mode: 'vr' }
    const protocol = window.location.protocol.startsWith('https') ? 'wss' : 'ws'
    const wsUrl = `${protocol}://${window.location.host}/`
    const socket = new SocketRemote(wsUrl, params)
    const client = new Client()
    await client.init({ socket })
    client.graphics.setViewport(viewportRef.current)
    client.graphics.enterVR() // todo: this should be publicUrl or soemthing
    setClient(client)
  }

  useEffect(() => {
    if (!client) return
    const onDisconnect = info => {
      // leave VR in production on disconnect
      if (!window.location.host.startsWith('localhost')) {
        client.graphics.leaveVR(false)
      }
      // show error
      setErr('Disconnected')
    }
    client.on('disconnect', onDisconnect)
    return () => {
      client.off('disconnect', onDisconnect)
    }
  }, [client])

  return (
    <div
      className='game'
      css={css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100dvw;
        height: 100dvh;
        background: rgba(0, 0, 0, 0.7);
        .game-viewport {
          position: absolute;
          inset: 0;
        }
        .game-main {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .game-main-box {
          width: 100%;
          max-width: 400px;
        }
        .game-main-btn {
          border: 2px solid white;
          padding: 20px;
          text-align: center;
          font-size: 24px;
          font-weight: 500;
          font-family: Pixel;
          cursor: pointer;
        }
        .game-error {
          text-align: center;
        }
      `}
    >
      <div className='game-viewport' ref={viewportRef} />
      <div className='game-main'>
        <div className='game-main-box'>
          <div className='game-main-btn' onClick={play}>
            <span>Play</span>
          </div>
          {err && <div className='game-error'>{err}</div>}
        </div>
      </div>
    </div>
  )
}
